import * as React from 'react';

import { ApplicationState, ConnectedReduxProps } from '../../../../store';
import { Dispatch } from 'redux';

import { Checkbox } from '@mui/material';
import { Ii18n } from '../../../../store/utils/contracts/i18n.interface';
import { connect } from 'react-redux';
import { getI18n } from '../../../../store/utils/i18n/strings.manager';
import { RemarkDTO as RemarkType } from '../../../../business/models/dto/svs/svs.dto';
import { tabRemarkFieldChange } from '../../../../store/details/svs/actions';
import { Role } from '../../../../store/shared/model';
import styles from './svs.module.css';

interface PropsFromState {
  readonly data: RemarkType;
  readonly locked: boolean;
}

interface PropsFromDispatch {
  readonly tabRemarkFieldChange: typeof tabRemarkFieldChange;
}

type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class Remark extends React.Component<AllProps> {
  private localization: Ii18n;

  constructor(props: AllProps) {
    super(props);

    this.localization = getI18n();
  }

  render() {
    return (
      <div>
        <div className={styles.content}>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <div className={styles.checkbox}>
                <Checkbox
                  checked={this.props.data.remarksSelected}
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    if (!this.props.locked) {
                      this.props.tabRemarkFieldChange({ ...this.props.data, remarksSelected: event.target.checked });
                    }
                  }}
                />
              </div>
            </div>
          </div>
          <div className={styles.row}>
            <div className={`${styles.item} ${styles.border}`}>
              <textarea className={styles.input}
                disabled={this.props.locked}
                placeholder={this.localization.get('details.svs.remark.placeholder')}
                value={this.props.data.remark}
                rows={4}
                onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                  this.props.tabRemarkFieldChange({ ...this.props.data, remark: event.target.value });
                }} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ details: { detailsSvs }, caseState: { selectedCase }, shared: { roles } }: ApplicationState): PropsFromState => ({
  data: detailsSvs.remark,
  locked: detailsSvs.locked || selectedCase.blocked || !roles.includes(Role.ExFiLoAd),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  tabRemarkFieldChange: (data: RemarkType) => dispatch(tabRemarkFieldChange(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(Remark);
